import {requestHelpers} from '../../../../../helpers';
import {updateTodoList} from '../../../../../actions/todo_list/todo_list';

export const actions = {
    SET_PRESS: "SET_PRESS",
    GENERAL_PRESS_REQUEST: "GENERAL_PRESS_REQUEST",
    GENERAL_PRESS_SUCCESS: "GENERAL_PRESS_SUCCESS",
    GENERAL_PRESS_ERROR: "GENERAL_PRESS_ERROR",
    DELETE_PRESS_SUCCESS: "DELETE_PRESS_SUCCESS",
};

export const setPress = (profile) => {
    const noData = profile.press.length === 0;
    return {
        type: actions.SET_PRESS,
        personId: profile.id,
        body: profile.press,
        noData,
    }
};

export const pressApiCall = (personId, payload, type, callbackToHOC) => {
    const requestType = type === 'CREATE' ? 'POST' : ( type === 'UPDATE' ? 'PUT' : "DELETE" );
    const endpoint = type === 'CREATE' ?  '' : ( payload.id ? `/${ payload.id }` : `/${ payload }`);

    const _payload = {...payload};

    if (requestType !== 'DELETE') {
        _payload.date = `${ payload.year.value }-0${ payload.month.value }`;
    }

    return (dispatch) => {
        dispatch({
            type: actions.GENERAL_PRESS_REQUEST,
            isPressFetching: true,
            isPressError: false,
        });

        requestHelpers
            .authenticatedPostRequest(`/profiles/${ personId }/press${endpoint}`, _payload, requestType)
            .then((response) => {
                callbackToHOC();
                payload.hasOwnProperty('id') ? _payload.id = _payload.id || response.data.id : payload;
                return dispatch({
                    type: requestType === 'DELETE' ? actions.DELETE_PRESS_SUCCESS : actions.GENERAL_PRESS_SUCCESS,
                    personId,
                    body: requestType === 'DELETE' ? payload : _payload,
                    isPressFetching: false,
                    isPressError: false,
                })
            })
            .catch((error) => {
                callbackToHOC( error );
                return dispatch({
                    type: actions.GENERAL_PRESS_ERROR,
                    isPressFetching: false,
                    isPressError: true,
                    error: error.status,
                })
            });
      dispatch(updateTodoList(personId, 8));
    }
};



// WEBPACK FOOTER //
// src/client/components/site/features/profile/actions/press.js